"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _reactFinalForm = require("react-final-form");

var _qs = _interopRequireDefault(require("qs"));

var _reactI18next = require("react-i18next");

var _rcTreeSelect = _interopRequireDefault(require("rc-tree-select"));

var _DownOutlined = _interopRequireDefault(require("@ant-design/icons/DownOutlined"));

var _CloseOutlined = _interopRequireDefault(require("@ant-design/icons/CloseOutlined"));

var _CloseCircleFilled = _interopRequireDefault(require("@ant-design/icons/CloseCircleFilled"));

var _LoadingOutlined = _interopRequireDefault(require("@ant-design/icons/LoadingOutlined"));

var _CompanyDictionary = require("../../context/CompanyDictionary");

var _withFieldWrapper = _interopRequireDefault(require("../hocs/withFieldWrapper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var TreeSelectComponent = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TreeSelectComponent, _Component);

  var _super = _createSuper(TreeSelectComponent);

  function TreeSelectComponent(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, TreeSelectComponent);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getDictionary", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(dictionary, parentId, search) {
        var _this$props, apiUrl, settings, urlParams, response, items;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setState({
                  error: false
                });

                _this$props = _this.props, apiUrl = _this$props.apiUrl, settings = _this$props.settings;
                urlParams = _qs["default"].stringify({
                  filter: {
                    dictionary: dictionary,
                    parent: Array.isArray(parentId) ? undefined : parentId,
                    parents: Array.isArray(parentId) ? parentId : undefined
                  },
                  pagination: JSON.stringify({
                    limit: 0
                  }),
                  sorting: JSON.stringify((0, _ramda.pathOr)({
                    field: 'value',
                    order: 'asc'
                  }, ['sorting'], settings)),
                  relations: ['parent']
                }, {
                  addQueryPrefix: true
                });
                _context.prev = 3;
                _context.next = 6;
                return fetch("".concat(apiUrl || '', "/api/company-dictionary-item").concat(urlParams));

              case 6:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 9;
                  break;
                }

                throw new Error();

              case 9:
                _context.t0 = _ramda.propOr;
                _context.t1 = [];
                _context.next = 13;
                return response.json();

              case 13:
                _context.t2 = _context.sent;
                items = (0, _context.t0)(_context.t1, 'items', _context.t2);
                return _context.abrupt("return", items);

              case 18:
                _context.prev = 18;
                _context.t3 = _context["catch"](3);

                _this.setState({
                  error: true,
                  loading: false
                });

                return _context.abrupt("return", []);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 18]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setDictionaryItems", function (items, dict, parent, parentDict, childrenPath) {
      var insertIndex = parent ? (0, _ramda.findIndex)((0, _ramda.propEq)('value', "".concat(parentDict, "_").concat(parent)), _this.state.treeData) : 0;
      var options = items.map(function (item, index) {
        return {
          value: "".concat(item.dictionary, "_").concat(item.id),
          pId: item.parent ? "".concat(parentDict, "_").concat(item.parent) : 0,
          label: item.value,
          data: _objectSpread(_objectSpread({}, item), {}, {
            childrenPath: parent ? [].concat((0, _toConsumableArray2["default"])(childrenPath), [index, 'children']) : [index, 'children']
          }),
          selectable: item.dictionary === _this.props.settings.dictionary,
          isLeaf: item.dictionary === _this.props.settings.dictionary
        };
      });

      _this.setState({
        options: _objectSpread(_objectSpread({}, _this.state.options), {}, (0, _defineProperty2["default"])({}, dict, (0, _ramda.concat)(_this.state.options[dict] || [], items))),
        treeData: childrenPath ? (0, _ramda.assocPath)(childrenPath, options, _this.state.treeData) : options,
        loading: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onLoadData", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(item) {
        var dictKey, parentKeys, dict;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!item.children) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", true);

              case 2:
                dictKey = _this.state.dicts[(0, _ramda.indexOf)(item.data.dictionary, _this.state.dicts) + 1];
                parentKeys = (0, _ramda.concat)(_this.state.loaded[dictKey] || [], [item.data.id]);
                _context2.next = 6;
                return _this.getDictionary(dictKey, item.data.id);

              case 6:
                dict = _context2.sent;

                _this.setState({
                  loaded: _objectSpread(_objectSpread({}, _this.state.loaded), {}, (0, _defineProperty2["default"])({}, dictKey, parentKeys))
                });

                _this.setDictionaryItems(dict, dictKey, item.data.id, item.data.dictionary, item.data.childrenPath);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x4) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (value) {
      _this.props.onChange((0, _ramda.compose)(_ramda.last, (0, _ramda.split)('_'))(value));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSelect", function (value, option) {
      _this.props.form.batch(function () {
        if (option.data.values) {
          option.data.values.map(function (item) {
            return _this.props.form.change(item.name, item.value);
          });
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getOptions", function () {
      var settings = _this.props.settings;
      var dictionaryKey = settings.parent || settings.dictionary;
      return (0, _ramda.pathOr)([], ['options', dictionaryKey], _this.state);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getParentOptions", function () {
      var _this$props2 = _this.props,
          contextOptions = _this$props2.contextOptions,
          parentField = _this$props2.parentField;
      return (0, _ramda.prop)(parentField, contextOptions);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getInputIcon", function () {
      var _this$state = _this.state,
          error = _this$state.error,
          loading = _this$state.loading;

      if (loading) {
        return /*#__PURE__*/_react["default"].createElement(_LoadingOutlined["default"], null);
      } else if (error) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "error-indicator",
          onClick: function onClick(e) {
            e.preventDefault();
            e.stopPropagation();

            _this.fetchAndSetDictionary();
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "error-icon"
        }, "!"));
      } else {
        return /*#__PURE__*/_react["default"].createElement(_DownOutlined["default"], null);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "filterTreeNode", function (value, node) {
      var search = (0, _ramda.toLower)("".concat(value || ''));
      return node.isLeaf && search ? (0, _ramda.contains)(search, (0, _ramda.toLower)("".concat(node.title || ''))) : false;
    });
    var parentDicts = (0, _ramda.values)(props.settings.parents);
    var dicts = [].concat((0, _toConsumableArray2["default"])(parentDicts || []), [props.settings.dictionary]);
    _this.state = {
      dicts: dicts,
      options: {},
      loaded: {},
      treeData: [],
      loading: false,
      error: false
    };
    return _this;
  }

  (0, _createClass2["default"])(TreeSelectComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchAndSetDictionary();
    }
  }, {
    key: "fetchAndSetDictionary",
    value: function () {
      var _fetchAndSetDictionary = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var _this2 = this;

        var settings, parentKeys, parentDicts, dicts, dict, items, dictItems, parentHash, parentIndex, parentValues, treeData, parentDict;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                settings = this.props.settings;
                parentKeys = (0, _ramda.keys)(settings.parents);
                parentDicts = (0, _ramda.values)(settings.parents);
                dicts = [].concat((0, _toConsumableArray2["default"])(parentDicts || []), [settings.dictionary]);
                dict = (0, _ramda.head)(dicts);
                this.setState({
                  loading: true,
                  dicts: dicts
                });

                if (!settings.multiple) {
                  _context3.next = 13;
                  break;
                }

                _context3.next = 9;
                return this.getDictionary(dict);

              case 9:
                items = _context3.sent;
                this.setDictionaryItems(items, dict);
                _context3.next = 23;
                break;

              case 13:
                _context3.next = 15;
                return Promise.all(dicts.map(function (name) {
                  return _this2.getDictionary(name);
                }));

              case 15:
                dictItems = _context3.sent;
                parentHash = {};
                parentIndex = {};
                parentValues = {};
                treeData = [];
                parentDict = null;
                dictItems.forEach(function (dictionary, index) {
                  dictionary.forEach(function (item, itemIndex) {
                    var childrenIndex = parentIndex["".concat(parentDict, "_").concat(item.parent)] || 0;

                    if (!item.parent) {
                      treeData.push({
                        value: "".concat(item.dictionary, "_").concat(item.id),
                        pId: 0,
                        label: item.value,
                        data: item,
                        children: [],
                        selectable: item.dictionary === _this2.props.settings.dictionary,
                        isLeaf: item.dictionary === _this2.props.settings.dictionary
                      });
                    } else {
                      treeData = (0, _ramda.assocPath)((0, _ramda.concat)(parentHash["".concat(parentDict, "_").concat(item.parent)], [childrenIndex]), {
                        value: "".concat(item.dictionary, "_").concat(item.id),
                        pId: item.parent ? "".concat(parentDict, "_").concat(item.parent) : 0,
                        label: item.value,
                        fullLabel: (0, _ramda.join)(' - ', (0, _ramda.concat)((0, _ramda.map)((0, _ramda.prop)('label'), parentValues["".concat(parentDict, "_").concat(item.parent)]), [item.value])),
                        data: _objectSpread(_objectSpread({}, item), {}, {
                          values: parentValues["".concat(parentDict, "_").concat(item.parent)]
                        }),
                        selectable: item.dictionary === _this2.props.settings.dictionary,
                        isLeaf: item.dictionary === _this2.props.settings.dictionary
                      }, treeData);
                    }

                    if (item.dictionary !== _this2.props.settings.dictionary) {
                      parentHash["".concat(item.dictionary, "_").concat(item.id)] = (0, _ramda.concat)(parentHash["".concat(parentDict, "_").concat(item.parent)] || [], [childrenIndex, 'children']);
                    }

                    parentValues["".concat(item.dictionary, "_").concat(item.id)] = (0, _ramda.concat)(parentValues["".concat(parentDict, "_").concat(item.parent)] || [], [{
                      name: parentKeys[index],
                      value: item.id,
                      label: item.value
                    }]);
                    parentIndex["".concat(parentDict, "_").concat(item.parent)] = childrenIndex + 1;
                  });
                  parentDict = dicts[index];
                });
                this.setState({
                  loading: false,
                  treeData: treeData
                });

              case 23:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchAndSetDictionary() {
        return _fetchAndSetDictionary.apply(this, arguments);
      }

      return fetchAndSetDictionary;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          loading = _this$state2.loading,
          error = _this$state2.error;
      var _this$props3 = this.props,
          _this$props3$input = _this$props3.input,
          value = _this$props3$input.value,
          name = _this$props3$input.name,
          settings = _this$props3.settings,
          t = _this$props3.t,
          disabled = _this$props3.disabled;
      var showFullPath = (0, _ramda.path)(['showFullPath'], settings) || true;
      var required = (0, _ramda.path)(['required'], settings);
      var multiple = (0, _ramda.path)(['multiple'], settings);
      var dictionary = (0, _ramda.path)(['dictionary'], settings);
      var placeholder = (0, _ramda.path)(['placeholder'], settings);
      var noOptionsMessage = (0, _ramda.path)(['noOptionsMessage'], settings);
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "".concat(name, "-tree-select")
      }, /*#__PURE__*/_react["default"].createElement(_rcTreeSelect["default"], {
        id: name,
        className: "".concat(error ? 'error' : ''),
        disabled: disabled,
        dropdownPopupAlign: {
          overflow: {
            adjustY: 0,
            adjustX: 0
          },
          offset: [0, 8]
        },
        value: value ? "".concat(dictionary, "_").concat(value) : value || null,
        treeData: this.state.treeData,
        filterTreeNode: this.filterTreeNode,
        treeNodeFilterProp: "label",
        treeNodeLabelProp: showFullPath ? 'fullLabel' : undefined,
        notFoundContent: loading ? t('loading') : noOptionsMessage || t('noOptionsMessage'),
        onChange: this.onChange,
        onSelect: this.onSelect,
        loadData: this.onLoadData,
        treeCheckable: multiple,
        showSearch: !multiple,
        allowClear: required,
        placeholder: placeholder,
        inputIcon: this.getInputIcon,
        switcherIcon: function switcherIcon(_ref3) {
          var loading = _ref3.loading,
              isLeaf = _ref3.isLeaf;
          return loading ? /*#__PURE__*/_react["default"].createElement(_LoadingOutlined["default"], null) : isLeaf ? null : /*#__PURE__*/_react["default"].createElement(_DownOutlined["default"], null);
        },
        removeIcon: /*#__PURE__*/_react["default"].createElement(_CloseOutlined["default"], null),
        clearIcon: /*#__PURE__*/_react["default"].createElement(_CloseCircleFilled["default"], null)
      }));
    }
  }]);
  return TreeSelectComponent;
}(_react.Component);

var withParentField = function withParentField(WrappedComponent) {
  return /*#__PURE__*/function (_Component2) {
    (0, _inherits2["default"])(WithParentField, _Component2);

    var _super2 = _createSuper(WithParentField);

    function WithParentField() {
      (0, _classCallCheck2["default"])(this, WithParentField);
      return _super2.apply(this, arguments);
    }

    (0, _createClass2["default"])(WithParentField, [{
      key: "render",
      value: function render() {
        var _this3 = this;

        var settings = this.props.settings;
        var parentField = (0, _ramda.prop)('parentField', settings);
        return /*#__PURE__*/_react["default"].createElement(_CompanyDictionary.CompanyDictionaryContext.Consumer, null, function (_ref4) {
          var options = _ref4.options,
              changeOptions = _ref4.changeOptions;

          var renderComponent = function renderComponent(value) {
            return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({
              parentField: parentField,
              parentFieldValue: value,
              contextOptions: options,
              changeContextOptions: changeOptions
            }, _this3.props));
          };

          return parentField ? /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
            name: parentField,
            subscription: {
              value: true
            }
          }, function (_ref5) {
            var value = _ref5.input.value;
            return renderComponent(value);
          }) : renderComponent();
        });
      }
    }]);
    return WithParentField;
  }(_react.Component);
};

var _default = (0, _withFieldWrapper["default"])(withParentField((0, _reactI18next.withTranslation)()(TreeSelectComponent)));

exports["default"] = _default;